import Axios from 'axios'
import { apiServer } from '../config'

export default {
  async authenticate(store) {
    const r = await Axios.post(`${apiServer}/api/your-details/authenticate?store=` + store).catch(() => { })
    if (r && r.status == 200) 
      return r.data.token
    return null
  },
  updateToken(token) {
    localStorage.rma_token = token
  },
  getToken() {
    return localStorage.rma_token ? localStorage.rma_token : ''
  },
  updateMemberToken(token) {
    localStorage.rma_member = token
  },
  getMemberToken() {
    return localStorage.rma_member ? localStorage.rma_member : ''
  }
}